import type { Grenade, Side } from "@69ly/shared";
import { markerUrl, type MarkerKind } from "../lib/marker-icons.ts";

/**
 * A grenade on the map: its impact where it lands, its launch where it is thrown
 * from. The side ring around it is CSS (the `side-t` / `side-ct` class of the marker).
 */
export function MarkerIcon({ kind, grenade, side, selected = false }: { kind: MarkerKind; grenade: Grenade; side: Side; selected?: boolean }) {
  return <img className={`marker-icon marker-${kind} side-${side}${selected ? " is-selected" : ""}`} src={markerUrl(kind, grenade, side, selected)} alt="" draggable={false} />;
}

/**
 * A grenade's icon outside the map (filters, lists, titles): the same drawing as
 * where it lands on the map, in its side's colour, or grey when no side applies.
 */
export function GrenadeIcon({ grenade, side = "t", size = 22, neutral = false, title }: { grenade: Grenade; side?: Side; size?: number; neutral?: boolean; title?: string }) {
  return (
    <img
      className={`grenade-icon side-${side}${neutral ? " is-neutral" : ""}`}
      src={markerUrl("impact", grenade, side)}
      width={size}
      height={size}
      alt={title ?? ""}
      title={title}
      draggable={false}
    />
  );
}

/**
 * The landing drawing alone, without its disc, in its side's colour: where room
 * is short (a stack's pill, a combo's marker) it reads far bigger than the disc.
 */
export function GrenadeMark({ grenade, side = "t", size = 22 }: { grenade: Grenade; side?: Side; size?: number }) {
  return <img className={`grenade-mark side-${side}`} src={markerUrl("glyph", grenade, side)} width={size} height={size} alt="" draggable={false} />;
}
